"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Step_1 = __importDefault(require("./components/Step"));
var Label_1 = __importDefault(require("./components/Label"));
var styles_1 = require("./styles");
function Stepper(props) {
    var stepsCount = react_1.default.Children.count(props.children);
    var steps = react_1.default.Children.map(props.children, function (step, index) {
        return react_1.default.cloneElement(step, {
            index: index,
            active: index === props.activeStep,
            completed: index < props.activeStep,
            stepsCount: stepsCount,
            style: props.style,
        });
    });
    return (react_1.default.createElement(styles_1.MainContainer, null, steps));
}
Stepper.Step = Step_1.default;
Stepper.Label = Label_1.default;
exports.default = Stepper;
//# sourceMappingURL=index.js.map